import GridRows from '../../grid/rows';
import app from '$$app';
import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.attachEvent('onTaskClick', (id, event) => {
    if (InlineEditors.isActive()) {
      InlineEditors.onClick();
    }

    GridRows.onTaskClick(id, event);
    app.trigger('hideResourcesPreviewListForTask');
    app.trigger('gantt:area:click');
  });
  // instance.attachEvent('onBeforeTaskSelected', (id, event) => false);
};
